import React from 'react';
import { createStore } from 'redux';
import moment from 'moment-timezone';
import { Provider } from 'react-redux';
import { ApolloClient } from 'apollo-client';
import {
  InMemoryCache,
  IntrospectionFragmentMatcher
} from 'apollo-cache-inmemory';
import { HttpLink } from 'apollo-link-http';
import { createUploadLink } from 'apollo-upload-client';
import { onError } from 'apollo-link-error';
import { ApolloLink } from 'apollo-link';
import { ApolloProvider } from 'react-apollo';
import { SnackbarProvider } from 'notistack';
import ConfirmProvider from 'providers/ConfirmProvide';

import { ThemeProvider } from '@material-ui/core/styles';

import rootReducer from 'reducers';

import Routes from './routes';
import { URI } from './config';
import theme from './theme';
import { CssBaseline } from '@material-ui/core';

const fragmentMatcher = new IntrospectionFragmentMatcher({
  introspectionQueryResultData: {
    __schema: {
      types: [] // no types provided
    }
  }
});

const store = createStore(rootReducer);

const client = new ApolloClient({
  link: ApolloLink.from([
    onError(({ graphQLErrors, networkError }) => {
      if (graphQLErrors)
        graphQLErrors.forEach(({ message, locations, path }) => {
          console.log(
            `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`
          );
          if (message === 'User is not logged in') {
            window.location = `/login`;
          }
        });
      if (networkError) console.log(`[Network error]: ${networkError}`);
    }),
    createUploadLink({ uri: URI, credentials: 'include' }),
    new HttpLink({
      uri: URI,
      credentials: 'include'
    })
  ]),

  cache: new InMemoryCache({ fragmentMatcher })
});

function App() {
  const localTz = moment.tz.guess();
  moment.tz.setDefault(localTz);
  moment.locale('en');
  moment.updateLocale('en', {
    week: {
      dow: 1
    }
  });

  const cssVariables = {
    baseUI: {
      color: '#0E8BB4'
    }
  };

  document.documentElement.style.setProperty('--base-color', '#0E8BB4');

  return (
    <ApolloProvider client={client}>
      <Provider store={store}>
        <ThemeProvider theme={{ ...theme, ...cssVariables }}>
          <CssBaseline />

          <ConfirmProvider>
            <SnackbarProvider
              autoHideDuration={3000}
              maxSnack={1}
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'right'
              }}
            >
              <Routes />
            </SnackbarProvider>
          </ConfirmProvider>
        </ThemeProvider>
      </Provider>
    </ApolloProvider>
  );
}

export default App;
